module.exports = __webpack_public_path__ + "static/thejetmanager.c4a80493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/thejetmanager.jpg
// module id = 1263
// module chunks = 35783957827783